import * as React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { GigRequestFormEventDetails } from '../../../../components/GigRequestForm'
import { getArtist } from '../../../../stores/Artist/ArtistReducer'

const ProfileDetailsGigRequestFormEventDetailsRoute = React.memo(() => {
  const artist = useSelector(getArtist)
  const history = useHistory()

  const handleNext = () => {
    history.push(`/${artist.artistType || 'artist'}/${artist.slug}/gigrequest/requester`)
  }

  const handlePrevious = () => {
    history.push(`/${artist.artistType || 'artist'}/${artist.slug}/gigrequest/event`)
  }

  return <GigRequestFormEventDetails onNext={handleNext} onPrevious={handlePrevious} />
})

export default ProfileDetailsGigRequestFormEventDetailsRoute
